import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AuthenticationService } from '../services';

// Guard that ensures the administrators is not signed in. If signed in
// redirect to the root url.
@Injectable({
  providedIn: 'root'
})
export class IsNotAuthenticatedGuard  {

  constructor(private authenticationService: AuthenticationService,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authenticationService.isSignedIn().pipe(
      map(isSignedIn => {
        if (isSignedIn) {
          this.router.navigate(['/']).then();
          return false;
        }
        return true;
      })
    );
  }

}
